import { ProtectedRoute } from '@/components/ProtectedRoute';
import { CreditsProvider } from '@/hooks/useCredits';

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

/**
 * Wraps children with ProtectedRoute (auth guard) + CreditsProvider.
 * Use this for all protected pages that need credit info.
 */
export function ProtectedLayout({ children }: ProtectedLayoutProps) {
  return (
    <ProtectedRoute>
      <CreditsProvider>
        {children}
      </CreditsProvider>
    </ProtectedRoute>
  );
}
